import {
  ButtonLinkPrimaryArrow,
  ButtonLinkQuartiary,
} from '@/components/button'
import { P1 } from '@/components/typography'
import useIsRay from '@/hooks/useIsRay'
import Section from '@/layouts/section'
import { routes } from '@/lib/constants'

const TopBar = () => {
  const isRay = useIsRay()

  return (
    <Section className="vacancyDetailTopbar">
      <ButtonLinkQuartiary
        className="vacancyDetailTopbar__btn"
        href={isRay ? routes.ray.vacancies : routes.rvdb.vacancies}
      >
        <P1>Vacature overzicht</P1>
      </ButtonLinkQuartiary>
    </Section>
  )
}

export default TopBar
